import React from "react";
import { Grid, Button, TextField, Tooltip } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import EditIcon from "@mui/icons-material/Edit";

const Detailsmodify = (props) => {
  const { topicname } = props;
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [state, setState] = React.useState({
    address: "",
    country: "",
    errorMessage: "",
  });

  const handleSubmitClick = (e) => {
    e.preventDefault();
    const data = {
      address: state.address,
      country: state.country,
    };
    fetch(`${process.env.REACT_APP_API_URL}/api/user_management/orgdetails`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        window.location.reload();
      })
      .catch((error) => {
        console.error(error);
        window.location.reload();
      });
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  return (
    <>
      <Tooltip title={`Edit ${topicname}`} arrow>
        <IconButton
          onClick={handleClickOpen}
          color="primary"
          aria-label={`Edit ${topicname}`}
          sx={{ borderRadius: "50px" }}
        >
          <EditIcon sx={{ fontSize: 14 }} />
        </IconButton>
      </Tooltip>
      <div style={{ alignItems: "center", display: "flex" }}>
        <Dialog
          fullWidth
          maxWidth="sm"
          open={open}
          onClose={handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">Update {topicname}</DialogTitle>
          <DialogContent>
            <Grid item md={20} xs={12}>
              {topicname === "Country" ? (
                <TextField
                  fullWidth
                  name="country"
                  id="country"
                  onChange={handleChange}
                  required
                  type="text"
                  value={state.country}
                  variant="outlined"
                />
              ) : (
                <TextField
                  fullWidth
                  name="address"
                  id="address"
                  onChange={handleChange}
                  required
                  type="text"
                  value={state.address}
                  variant="outlined"
                />
              )}
            </Grid>
          </DialogContent>
          <DialogActions>
            <Tooltip title="Cancel" arrow>
              <Button
                variant="contained"
                onClick={handleClose}
                color="primary"
                sx={{ borderRadius: "50px", px: 3, py: 1 }}
              >
                Cancel
              </Button>
            </Tooltip>
            <Tooltip title="Update" arrow>
              <Button
                variant="contained"
                type="submit"
                onClick={handleSubmitClick}
                color="primary"
                sx={{ borderRadius: "50px", px: 3, py: 1 }}
              >
                Update
              </Button>
            </Tooltip>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
};

export default Detailsmodify;